export const FINANCE_WEBCLIENT_MODULE = undefined;
